import React from 'react';
import { UploadController } from './use-upload-controller';

//  Initialize with empty.  The Provider will fill this in once it gets the controller assembled
export const UploadControllerContext = React.createContext<UploadController>({} as UploadController);

//  This exposes the controller to every child that wants to use it :-)
export const useUploadProvider = () => React.useContext(UploadControllerContext);
